import { Link } from 'react-router-dom';

// The one page header (ENTRAID-347 redesign, brand/onguard/README.md "Page header"): exactly one h1 in Montserrat
// ExtraBold navy, an optional one-line subline that says what the page is for and how fresh it is, and on the right at
// most one primary action plus one secondary. Detail pages add a back link above the title. No breadcrumb on customer
// pages: the sidebar and the h1 answer "where am I".

/**
 * @param {{
 *   title: string, subline?: import('react').ReactNode,
 *   action?: import('react').ReactNode, secondary?: import('react').ReactNode,
 *   back?: { to: string, label: string }, className?: string,
 * }} props
 * `action` is the page's one primary button (or a labelled switch); `secondary` an optional second control.
 */
export default function PageHeader({ title, subline = null, action = null, secondary = null, back = null, className = '' }) {
  return (
    <header className={`mb-6 flex flex-col gap-4 sm:flex-row sm:items-end ${className}`.trim()} data-page-header="">
      <div className="min-w-0">
        {back ? (
          <Link
            to={back.to}
            className="mb-2 inline-flex items-center gap-1 text-sm font-semibold text-ipc-light hover:underline"
            data-page-back=""
          >
            <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true" focusable="false">
              <polyline points="15 18 9 12 15 6" />
            </svg>
            {back.label}
          </Link>
        ) : null}
        <h1 className="break-words">{title}</h1>
        {subline ? <p className="mt-1.5 text-[15px] text-ipc-muted" data-page-subline="">{subline}</p> : null}
      </div>
      {action || secondary ? (
        <div className="flex flex-wrap items-center gap-2.5 sm:ml-auto sm:shrink-0" data-page-actions="">
          {secondary}
          {action}
        </div>
      ) : null}
    </header>
  );
}
